import { TriState } from "../../../models";
import { BaseElement } from "../BaseElement";
import { renderEnumSelect } from "./EnumSelect";

export function renderTriState(
    root: BaseElement,
    object: any,
    prop: string,
    label: string,
    helpMsg: string
) {
    return renderEnumSelect(root, TriState, object, prop, label, helpMsg);
}
